export default "__VITE_ASSET__CofmjyCz__"